import { useState } from 'react';
import dateFormat from 'date-fns/format';

import DataTable from 'components/CncUI/DataTable';
import Modal from 'components/CncUI/Modal';
import Link from 'components/CncUI/Link';

const TruliooLogs = props => {
  const { records } = props;
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({ label: '', data: {} });

  const openModal = (label, data) => {
    setModalData({ label, data: JSON.parse(data || {}) });
    setOpen(true);
  };

  const modalLink = (label, title, data) => {
    if (!data) return '';
    return <Link onClick={() => openModal(title || label, data)}>{label}</Link>;
  };

  const formatDate = timestamp => {
    const date = new Date(parseInt(timestamp, 10));
    return dateFormat(date, 'MM/dd/yyyy HH:mm:ss');
  };

  const formatFrom = row => {
    return `${row.verify} validation`;
  };
  const formatInput = row => {
    return modalLink('Click here to view user input', 'User Input', row.input);
  };
  const formatData = row => {
    return modalLink(
      'Click here to view validation response',
      'Validation Response',
      row.data,
    );
  };

  const rows = (records || []).map(row => {
    return {
      date: row.createdAt,
      loginId: row.loginId,
      from: formatFrom(row),
      input: formatInput(row),
      data: formatData(row),
    };
  });

  const columns = [
    { field: 'date', value: ({ date }) => formatDate(date) },
    { field: 'loginId', label: 'User Okta ID' },
    { field: 'from' },
    { field: 'input', label: 'User Input' },
    { field: 'data', label: 'Identity Validation' },
  ];

  return (
    <>
      <DataTable
        transparent
        columns={columns}
        data={rows}
        pageSize={5}
        sort="date"
        order="desc"
      />
      <Modal open={open} onClose={() => setOpen(false)}>
        <Modal.Title>{modalData.label}</Modal.Title>
        <Modal.Content>
          <pre>{JSON.stringify(modalData.data, null, 2)}</pre>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default TruliooLogs;
